<template>
  <div id="project-video-player">
    <div class="columns">
      <div class="column">
        <iframe src="https://player.vimeo.com/video/376363469?title=0&byline=0&portrait=0" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen id="video2019"></iframe>
      </div>
      <div class="column">
        <ul id="project-list">
          <li v-for="(p, name)  in projectList" v-bind:key="p.id"  >
            <a v-on:click="playSketch(name)">
              <span class = "material-icons md-24 is-size-7">play_arrow</span> {{ p.name }}
            </a>
            <a :href="'http://programalaplaza.medialab-prado.es/#/editor/'+ p.id" class="is-text-7 has-text-right link-code" style=""> <span class = "material-icons md-24">code</span> </a>
          </li>
        </ul>

      </div>
    </div>

  </div>
</template>
<script>
import axios from 'axios'
import Player from '@vimeo/player'
export default {

  name: '',
  data: () => ({
    projectList: [],
    idPlayer: null
  }),
  methods: {
    getVideoList () {
      axios.get('/static/video2019.json')
        .then(d => { this.projectList = d.data.results })
    },
    playSketch (i) {
      console.log(i)
      this.idPlayer.play()
      this.idPlayer.setCurrentTime(i * 30 + 5)
    }
  },
  mounted () {
    this.idPlayer = new Player('video2019')
  },
  created () {
    this.getVideoList()
  }
}
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
}
::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0,0,0,.5);
    box-shadow: 0 0 1px rgba(255,255,255,.5);
}
#project-list {
  max-height: 360px;
  overflow: scroll;
  li{
    font-size:13px;
    padding-bottom:4px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
  }

  li a:hover{
    color:black;
  }

  li a.link-code{
    color:black;
    line-height:2px;
  }

  li a.link-code:hover{
    color:#777;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Home/ProjectVideoPlayer.vue